import { ConsumerAuctionDTO } from "../types/types";

import { atomWithStorage } from "jotai/utils";

export const auctionAtomCopy = atomWithStorage<Partial<ConsumerAuctionDTO>>(
  "auctionAtomCopy",
  {},
  undefined,
  { getOnInit: true }
);
